module.exports = __webpack_public_path__ + "static/img/java.b172e708.png";